export const walletsApiPaths = {
    wallets: 'companies/:companyId/requests/:requestId/wallets',
    walletsXeroBankFeeds: 'companies/:companyId/wallets/xero-bank-feeds',
    connectXeroBankFeed: 'companies/:companyId/wallets/:walletId/xero-bank-feed/connect',
} as const;
